<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
          <h2>GESTION DES AXES</h2>
          <ul>
            <li><a routerLink="/">TABLEAU DE BORD</a></li>
            <li><i class="icofont-simple-right"></i></li>
            <li>GESTION DES AXES</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container pt-100 pb-170">
  <div class="card shadow-2 rounded-0 border-0">
    <div class="card-body">
      <app-table-loader [length]="4" *ngIf="!axes"/>

      <p-table
        *ngIf="axes"
        [value]="axes"
        [paginator]="true"
        [rows]="10"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[10, 25, 500]"
        [resizableColumns]="true"
        columnResizeMode="expand"
      >
        <ng-template pTemplate="caption">
          <div class="flex">
            <button type="button" pButton pRipple icon="pi pi-file" class="mr-2 rounded-5" pTooltip="CSV" tooltipPosition="bottom"></button>
            <button type="button" pButton pRipple icon="pi pi-file-excel" class="p-button-success mr-2 rounded-5"  pTooltip="XLS" tooltipPosition="bottom"></button>
            <button type="button" pButton pRipple icon="pi pi-file-pdf" class="p-button-warning mr-2 rounded-5" pTooltip="PDF" tooltipPosition="bottom"></button>
            <button type="button" (click)="open(content)" pButton pRipple icon="pi pi-plus" class="p-button-info ml-auto rounded-5" pTooltip="Nouvel axe" tooltipPosition="bottom"></button>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">NOM DE L'AXE <p-sortIcon field="name"></p-sortIcon></th>
            <th class="text-end" pSortableColumn="created_at">DATE DE CREATION <p-sortIcon field="created_at"></p-sortIcon></th>
            <th pSortableColumn="action_user.first_name">UTILISATEUR <p-sortIcon field="action_user.first_name"></p-sortIcon></th>
            <th class="text-end">ACTIONS</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-axe>
          <tr>
            <td>{{ axe.name }}</td>
            <td class="text-end">{{ axe.created_at|date:'dd/MM/yyyy' }}</td>
            <td>{{ axe.action_user.first_name }} {{ axe.action_user.last_name.toString() }}</td>
            <td class="text-end">
              <button type="button" pButton pRipple icon="pi pi-eye" class="p-button-success p-button-sm rounded-5 btn-sm"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header px-5 bg-default text-white">
    <h4 class="modal-title text-white" id="modal-basic-title">NOUVEL AXE</h4>
    <button type="button" class="btn-close text-white" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body p-5">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <div class="row g-4">
        <div class="col-lg-12">
          <div class="form-group">
            <label>TITRE DE L'AXE <span class="text-danger">(REQUIS)</span></label>
            <input type="text" formControlName="name" class="form-control">
            <small class="text-bg-danger" *ngIf="
                                        form.get('name')
                                            .touched &&
                                        form
                                            .get('name')
                                            .hasError('required')
                                    ">Champs obligatoire.</small>
          </div>
        </div>

        <div class="col-lg-12 col-md-12">
          <div class="form-group">
            <label>DESCRIPTION DE L'AXE
              <span class="text-danger">*</span></label>
            <div class="NgxEditor__Wrapper">
              <ngx-editor-menu [editor]="editor">
              </ngx-editor-menu>
              <ngx-editor formControlName="description" cols="30" [editor]="editor"
                          [ngModel]="html" [placeholder]="'Saisissez ici...'"></ngx-editor>
            </div>
            <small class="text-bg-danger" *ngIf="
                                        form.get('description')
                                            .touched &&
                                        form
                                            .get('description')
                                            .hasError('required')
                                    ">Champs obligatoire.</small>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer p-2">
    <div class="text-left">
      <button type="submit" [disabled]="form.invalid || loading" class="btn btn-green rounded-5">ENREGISTRER  <i *ngIf="loading" class="icofont-spinner-alt-1 icofont-spin"></i></button>
    </div>
    <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button> -->
  </div>
</ng-template>
